import { Task, TaskFormData, CalendarSlot, UserStats } from '../types/task';
import { firestoreService } from './firestore';

// Task operations using Firestore
export const fetchTasks = async (): Promise<Task[]> => {
  try {
    return await firestoreService.getTasks();
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};

export const createTask = async (taskData: TaskFormData): Promise<Task> => {
  try {
    return await firestoreService.createTask(taskData);
  } catch (error) {
    console.error('Error creating task:', error);
    throw error;
  }
};

export const updateTask = async (taskId: string, updates: Partial<Task>): Promise<void> => {
  try {
    await firestoreService.updateTask(taskId, updates);
  } catch (error) {
    console.error('Error updating task:', error);
    throw error;
  }
};

export const deleteTask = async (taskId: string): Promise<void> => {
  try {
    await firestoreService.deleteTask(taskId);
  } catch (error) {
    console.error('Error deleting task:', error);
    throw error;
  }
};

export const completeTask = async (taskId: string): Promise<void> => {
  try {
    await firestoreService.completeTask(taskId);
  } catch (error) {
    console.error('Error completing task:', error);
    throw error;
  }
};

export const rescheduleTask = async (taskId: string, scheduledTime: Date): Promise<void> => {
  try {
    await firestoreService.updateTask(taskId, { scheduledTime });
  } catch (error) {
    console.error('Error rescheduling task:', error);
    throw error;
  }
};

// Calendar slots - for now, return empty array (can be implemented later)
export const fetchCalendarSlots = async (date: Date): Promise<CalendarSlot[]> => {
  // TODO: Implement calendar slots in Firestore
  return [];
};

// User stats using Firestore
export const fetchUserStats = async (): Promise<UserStats> => {
  try {
    const stats = await firestoreService.getUserStats();
    
    // Convert Firestore stats to UserStats interface
    const totalTasks = (stats as any).totalTasks || 0;
    const completedTasks = (stats as any).completedTasks || 0;
    const currentStreak = (stats as any).currentStreak || 0;
    const earnedCredits = (stats as any).earnedCredits || 0;
    const availableCredits = (stats as any).availableCredits || 0;
    
    return {
      totalTasks,
      completedTasks,
      completionRate: totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0,
      streakDays: currentStreak,
      averageTasksPerDay: 0, // TODO: Calculate based on task history
      earnedCredits,
      availableCredits
    };
  } catch (error) {
    console.error('Error fetching user stats:', error);
    throw error;
  }
};

export const updateUserStats = async (stats: Partial<UserStats>): Promise<void> => {
  try {
    await firestoreService.updateUserStats(stats);
  } catch (error) {
    console.error('Error updating user stats:', error);
    throw error;
  }
}; 